import api from "@/api";

export default {
  adminMatrix(params = {}) {
    return api
      .get("/api/cham-cong/admin/matrix", { params })
      .then((r) => r.data);
  },
  quickAttendance(payload) {
    return api.post("/api/admin/quick/attendance", payload).then((r) => r.data);
  },
  quickOvertime(payload) {
    return api.post("/api/admin/quick/overtime", payload).then((r) => r.data);
  },
  quickSunday(payload) {
    return api.post("/api/admin/quick/sunday", payload).then((r) => r.data);
  },
};
